import { request, requestFlatGet } from '../../utils/request';
import { logger } from '@/common';

// 获取推荐商品列表数据
export function getHomeGoods(params) {
  return new Promise((resolve, reject) => {
    request('/v1/goods/home-goods', { params, login: false })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 获取推荐商品列表数据
export function channelDetails(channelId, params) {
  return new Promise((resolve, reject) => {
    request('/v2/channel/details/' + channelId, { params, login: false })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 *
 * @param {*} params
 * @returns 专场推荐商品列表
 */
export const recommendGoodsList = (channelId, params) => {
  return new Promise((resolve, reject) => {
    request(`/v2/channel/${channelId}/recommend/goods/list`, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

// 获取商品列表数据
export function getGoods(params) {
  return new Promise((resolve, reject) => {
    request('/v1/goods/search', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 获取品牌商品详情
export function getBrandGoods_v2(brand_id, params) {
  return new Promise((resolve, reject) => {
    request('/v2/brand/goods/' + brand_id, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 品牌门店信息列表
 * @param {object} params
 */
export function storeInfoList(params = {}) {
  return new Promise((resolve, reject) => {
    request('/v2/brand/city/store/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
}

/**
 * 品牌门店区域列表（移植 mall_h5 lib/request 的 storeAreaList）
 * 入参 { cancel_city_id, cancel_brand_id, brand_id, lon, lat, is_parent }
 * 返回 { [品牌分类]: { title, item: [{ region_id, region_name, list_count }] } }
 */
export function storeAreaList(params = {}) {
  return new Promise((resolve, reject) => {
    request('/v2/pd-cancel/brand/area/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
}

/**
 * 某区域下的门店列表（移植 mall_h5 lib/request 的 storeInfoList_v2）
 * 入参 { cancel_region_id, cancel_brand_id, brand_id, lon, lat, cancel_city_id, is_panda_store }
 * 返回门店数组
 */
export function storeInfoList_v2(params = {}) {
  return new Promise((resolve, reject) => {
    request('/v2/pd-cancel/brand/area/store/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
}

// 品牌商品搜索
export function getGoods_v2(brand_id, params) {
  params.brand_ids = brand_id;
  if (!brand_id) delete params.brand_ids;
  return new Promise((resolve, reject) => {
    request('/v2/goods/search/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 商品详情
export function searchBirthdayGoods(params) {
  return new Promise((resolve, reject) => {
    request('/v2/goods/search/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 商品详情
export function getGoodsDetail(params, id) {
  return new Promise((resolve, reject) => {
    request(`/v1/goods/details/${id}`, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
export function getGoodsDetail2(params, id) {
  return new Promise((resolve, reject) => {
    request(`/v2/goods/details/${id}`, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
export function getGoodsSku_v2(id, params) {
  return new Promise((resolve, reject) => {
    request(`/v2/goods/details/${id}/skuInfo`, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 专场分类
export function classify(params) {
  return new Promise((resolve, reject) => {
    request('/v1/category/cate', { params, login: false })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 专场分类更新
export function classify_v2(params) {
  return new Promise((resolve, reject) => {
    request('/v2/category/index', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 获取专场下一级分类列表
export function classificationList(params) {
  return new Promise((resolve, reject) => {
    request('/v2/category/prent/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
}
// 获取一级分类下的品牌
export function reqbrandList(params) {
  return new Promise((resolve, reject) => {
    request('/v2/brand/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
}
// 品牌下的商品数据
export function reqbrandListAndgoods(params) {
  return new Promise((resolve, reject) => {
    request('/v2/brand/goods/recommend/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
}
export function getCancelBrand(params) {
  return new Promise((resolve, reject) => {
    request('/v2/pd-cancel/brand/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
}
/**
 * 核销品牌列表
 * @param {*} params
 * @returns
 */

// 专场列表
export function getMenu(params) {
  return new Promise((resolve, reject) => {
    request('/v1/home/left-menu', { params, login: false })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 品牌列表
export function getBrand(params) {
  return new Promise((resolve, reject) => {
    request('/v1/goods/searchFiltrate', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 品牌列表更新
export function getBrand_v2(params) {
  return new Promise((resolve, reject) => {
    request('/v2/brand/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 检测库存
export function checkStock(params) {
  return new Promise((resolve, reject) => {
    request('/v1/goods/checkStock', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 检测库存更新
export function postCheckStock(params) {
  return new Promise((resolve, reject) => {
    request('/v2/goods/checkStock', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// ===== banner 链接规整 =====
// 后端 banner 的 link 可能是绝对地址（mall/pcmall 域名）或 h5 的历史路径，统一处理：
//   useInternalLink = true（默认）：截掉自有域名，转成项目内路径，交给 router 跳转
//   useInternalLink = false：保留绝对地址，但把 mall 域名换成 pcmall
const BANNER_HOST_RE = /^https?:\/\/(?:mall|pcmall|pcmall-test|www)\.pandayoufu\.com/i;
// 历史路径 → PC 现有路由（只替换 path，query 保留）
const BANNER_PATH_MAP = [
  // 品牌详情：h5 是 branddetails，PC 路由是 brand_details
  { re: /^\/birthday\/branddetails/i, to: '/birthday/brand_details' },
  // h5 的分类详情页 PC 没有，落到生日商品列表
  { re: /^\/birthday\/classifydetails/i, to: '/birthday/list' },
  // /activity、/partition 的兑换版式已合并到 /exchange，mode 参数不再需要
  { re: /^\/(?:activity|partition)/i, to: '/exchange', dropMode: true }
];

export function normalizeBannerLink(link, useInternalLink = true) {
  if (!link || typeof link !== 'string') return link || '';
  let url = link.trim();
  if (!useInternalLink) {
    // 不转内部跳转：只把 mall 域名换成 pcmall
    return url.replace(
      /^(https?:\/\/)mall\.pandayoufu\.com/i,
      '$1pcmall.pandayoufu.com'
    );
  }
  if (BANNER_HOST_RE.test(url)) {
    url = url.replace(BANNER_HOST_RE, '') || '/';
  }
  // 非项目内路径（外部地址）原样返回
  if (url.charAt(0) !== '/') return url;
  const [path, query = ''] = url.split('?');
  const hit = BANNER_PATH_MAP.find(item => item.re.test(path));
  if (!hit) return url;
  const nextPath = path.replace(hit.re, hit.to);
  let nextQuery = query;
  if (query && hit.dropMode) {
    nextQuery = query
      .split('&')
      .filter(p => p && !/^mode=/.test(p))
      .join('&');
  }
  return nextQuery ? `${nextPath}?${nextQuery}` : nextPath;
}

// banner（用平铺 GET：requestFlatGet）
// 对照结论：h5 的 channelBannerList 走 createHttpService 的 get —— 参数【平铺】进 query +
// platform/token/city_id/channel_id 注入 + header.sign/timestamp 签名。
// PC 主请求层会把参数包成 { header, body } 信封（GET 时整个信封进 query），
// 这个接口按 query 平铺取参，所以单独用 requestFlatGet。
// useInternalLink：link 统一规整成项目内路径（默认），调用方按是否以 '/' 开头决定
// 走 router 还是新窗口；传 false 则保留绝对地址（只把 mall 域名换成 pcmall）。
export function getBanner(params, useInternalLink = true) {
  return new Promise(resolve => {
    requestFlatGet('/v1/channel/banner-list', params || {})
      .then(res => {
        // 统一成 { list, channel_name }，避免返回结构变化时调用方取不到 list
        const data = (res && res.data) || res || {};
        const source = Array.isArray(data) ? data : data.list || [];
        // banner 的 link 可能是 mall/pcmall 域名或 h5 历史路径，这里统一规整
        const list = source.map(item => ({
          ...item,
          link: normalizeBannerLink(item.link, useInternalLink)
        }));
        if (Array.isArray(data)) {
          resolve({ list });
          return;
        }
        resolve({ ...data, list });
      })
      .catch(err => {
        // 调用方（10+ 处）都是 .then 且没有 .catch，这里兜住并打出原因，
        // 避免控制台出现 Uncaught (in promise)（业务码非 0 时会走到这里）
        const { data = {}, status } = err || {};
        logger({
          message: `获取 banner 失败：${data.message ||
            data.msg ||
            status ||
            ''}`,
          error: err
        });
        resolve({ list: [] });
      });
  });
}

//判断是否支持视听
export const movieConfig = params => {
  return new Promise((resolve, reject) => {
    request('/v2/movies/config', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
};

export function activityIndex(params) {
  return new Promise((resolve, reject) => {
    request('/v1/activity/index', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function activityList(params) {
  return new Promise((resolve, reject) => {
    request('/v1/activity/goods/index', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 品牌下的商品数据
export function brandGoods(params) {
  return new Promise((resolve, reject) => {
    request('/v2/brand/goods/recommend/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 一级分类推荐产品列表
export function reqgoodsCateList(params) {
  return new Promise((resolve, reject) => {
    request('/v2/goods/cate/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
